<mat-dialog-content>
  @for (photo of availableImages; track photo) {
    <div (click)="photoPicked(photo);photoId=photo" class="photo">
      @if (photoId===photo && currentCrop.value) {
        <img
      [src]="
                  {photoId:photo}
                    | getImageUrl
                      : (photo | getPhotoGroupFromPhotoId:imageRelations)
                      : 'anyone'
                      : context
                      : contextId
                      : 400
                    | async | cropCanvasPieceImage :currentCrop.value | async" />
      } @else {
        <img
        [src]="
                  {photoId:photo}
                    | getImageUrl
                      : (photo | getPhotoGroupFromPhotoId:imageRelations)
                      : 'anyone'
                      : context
                      : contextId
                      : 400
                    | async " />
        }
        @if (photoId===photo) {
          <lib-button (click)="startCrop(photo)" icon-only>
            <mat-icon>crop</mat-icon>
          </lib-button>
        }
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <lib-button (click)="save()">Zapisz</lib-button>
    <lib-button bare mat-dialog-close>Anuluj</lib-button>
  </mat-dialog-actions>
